import { classnames } from '@/helpers/general';
import { formatTabCount } from '../SerpTabs.helpers';

const TabCountBadge = ({ count, isActive }: { count: number; isActive: boolean }) => (
  <span
    className={classnames(
      'px-2xs h-lg flex min-w-[20px] items-center justify-center rounded-full text-xs font-bold',
      isActive ? 'bg-bg_primary text-fg_primary_inverse' : 'bg-bg_secondary_bold text-fg_secondary',
    )}>
    {formatTabCount(count)}
  </span>
);

export const TabCountSkeleton = () => (
  <span
    aria-hidden="true"
    className="h-lg bg-bg_secondary_bold block w-[24px] rounded-full motion-safe:animate-pulse"
  />
);

export default TabCountBadge;
